import MultiText from './MultiText';
export default MultiText;
